import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { EmptyModule } from '../empty/empty.module';
import { NavigationHistoryComponent } from './navigation-history.component';
import { TimeAgoModule } from '../time-ago/time-ago.module';
import { FallbackViewComponent } from '@tekus/design-system/components/fallback-view';

@NgModule({
  declarations: [
    NavigationHistoryComponent
  ],
  imports: [
    CommonModule,
    PipesModule,
    ToolbarModule,
    TranslateModule,
    EmptyModule,
    TimeAgoModule,
    FallbackViewComponent
  ],
  exports:[
    NavigationHistoryComponent
  ]
})
export class NavigationHistoryModule { }
